/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Seccion_Formacion from "./Secciones/Seccion_Formacion";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import {BrowserRouter as Router, Route, Routes} from 'react-router';

const Pagina = () => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Router>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Formacion/>}/>
                        <Route path={"/Formacion/:id"} element={<Seccion_Formacion/>}/>
                    </Routes>
                </Grid>



            </Router>

        </Grid>
    )

}
export default Pagina